import React, { Component } from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import Typography from '../../UI/Typography'
import ScrollNav from '../../UI/ScrollNav'
import SplitSection from '../../UI/Slider/SplitSection'
import TabSlider from '../../UI/TabSlider'
import { device } from '../../../utils/helpers'
import { Element, Events } from 'react-scroll'

import Feature from '../../UI/Feature'
import { features } from './Contenimento'
import CasettaIcon from '../../UI/Icons/CasettaIcon'
import GazebiIcon from '../../UI/Icons/GazebiIcon'
import AudioIcon from '../../UI/Icons/AudioIcon'
import LuciIcon from '../../UI/Icons/LuciIcon'

import {
  casettaSlides,
  audioSlides,
  luciSlides,
  gazeboSlides1,
  gazeboSlides2
} from '../../Helpers/Slides'

import {
  Section,
  Title,
  BigTitle,
  FeatureWrapper,
  Features,
  Menu,
  Content
} from './Altre'

const Icon = ({ icon, ...props }) => (
  // Needed to pass props to the element which is also being
  // passed as props
  React.cloneElement(icon, { ...props })
)

const StyledIcon = styled(Icon)`
  width: ${props => props.width};
  height: ${props => props.height};

  @media ${device.tablet} {
    width: ${props => props.tabWidth};
    height: ${props => props.tabHeight};
  }
`

const navItems = [
  {
    name: 'Casetta',
    icon: <StyledIcon icon={<CasettaIcon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  },
  {
    name: 'Gazebi',
    icon: <StyledIcon icon={<GazebiIcon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  },
  {
    name: 'Audio',
    icon: <StyledIcon icon={<AudioIcon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  },
  {
    name: 'Luci',
    icon: <StyledIcon icon={<LuciIcon />} width='75px' height='75px' tabWidth='3.90625VW' tabHeight='3.90625VW' fill='#4d4d4d' />
  }
]

export const casetta = {
  description: 'Abbiamo ideato e realizzato un nuovo concetto di strutture smontabili atte ad accogliere l’area check-in del vostro evento.;La casetta ha un tempo di montaggio ridotto grazie alla tecnica “puzzle”.;Disponiamo di moduli 3x2 m, 7x3 m e 8x3 m ma siamo in grado di realizzare strutture con metrature differenti a seconda dell’esigenza.',
  technical: [
    'Modulo 3×2 mt, peso 3 q',
    'Materiali dotati di certificazione e resistenza al vento',
    'Non necessitano di ancoraggio al suolo',
    'Tutte le strutture sono resistenti all’acqua',
    'Dotati di allaccio elettrico',
    'Pavimento galleggiante in legno multistrato cileno (25mm) rivestite con lamiera zincata',
    'Strutture portanti in tubo quadro di ferro zincato',
    'Pareti modulari di abete massiccio ignifughe con certificazione antincendio',
    'Possibilità di brandizzazione delle strutture',
    'Tetto in lamiera zincata, fissato a telai in liste di legno d’abete',
    'Chiusura integrale delle strutture (porte con serrature)',
    'Finestroni in plexiglass',
    'Finiture interne a scelta (mensole, aggancio schermi TV, TV 55 pollici, desk, tavoli d’appoggio etc)'
  ]
}

export const gazebo5x5 = {
  description: 'Gonfiabile di alto livello qualitativo, realizzato con tessuti resistenti e adatti ad ogni contesto, sia per utilizzo indoor che outdoor.;Il gonfiabile “spider” 5x5 metri circolare a quattro gambe si monta in poco meno di dieci minuti grazie al gonfiatore elettrico. La struttura è un’ottima copertura dagli agenti atmosferici (sole e pioggia) durante gli eventi sportivi oltre ad avere un grande impatto visivo ove installata.;Completo di sacca di trasporto, funi di ancoraggio, motore soffiatore super silenzioso e libretto di istruzioni.',
  technical: [
    'Materiale: poliammide 420 ad alta tenacità con basi rinforzate in pvc',
    'Compressore  elettrico per gonfiaggio 220v – 680w esterno',
    'Dimensioni: 5 m diametro',
    'Materiali dotati di certificazione',
    'Desk personalizzati formato 172×98 cm (su richiesta)'
  ],
  tabs: [
    {
      title: 'Cupola',
      content: 'La cupola, in tessuto antivento e antipioggia di colore nero, può essere brandizzata con la stampa in negativo del logo della manifestazione.',
      goToSlideIndex: 0
    },
    {
      title: 'Pareti',
      content: 'Le pareti, in tessuto antivento e antipioggia di colore nero, possono essere brandizzate con la stampa in negativo del logo della manifestazione.',
      goToSlideIndex: 0
    }
  ]
}

export const gazebo3x3 = {
  description: 'Struttura di 9 mq in alluminio di facile assemblaggio, con pareti in tessuto antivento personalizzabili e copertura in 4 differenti colori. Completa di borsa con ruote e picchetti.',
  technical: [
    'Dimensioni: 9 mq di ingombro',
    'Telo bandiera nautico antivento 115 gr',
    'Materiali dotati di certificazione',
    'Desk personalizzato formato 172×98 cm (su richiesta)'
  ],
  tabs: [
    {
      title: 'Pareti',
      content: 'Le pareti, in tessuto antivento e antipioggia, possono essere brandizzate con la stampa del logo della manifestazione.',
      goToSlideIndex: 0
    }
  ]
}

export const audio = {
  description: 'Noleggiocampi.it dispone di diverse soluzioni per garantire il migliore impianto audio al vostro evento. Da casse audio autoportanti di facile e rapida installazione fino a grandi impianti di amplificazione a sospensione installati sui ring di americane dotati di mixer e microfono senza filo.',
  description: 'Noleggiocampi.it dispone di diverse soluzioni per garantire il migliore impianto audio al vostro evento. Da casse audio autoportanti, di facile e rapida installazione, fino a grandi impianti di amplificazione a sospensione, installati sui ring di americane. Dotati di mixer e microfono senza filo.',
  technical: <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <div>
      <span>JBL VRX 900</span><br />
      <span>QSC K-series</span><br />
      <span>DB TECHNOLOGIES DVA MINI</span><br />
      <span>HK</span><br />
      <span>EAW 260-650-850</span><br />
      <span>QUBE AUDIO</span><br />
      <span>ERJK K4</span><br />
    </div>
    <div>
      <span>Amplificatori Crown e Labgruppen</span><br />
      <span>Mixer digitale ALLEN&HEATH GLD112</span><br />
      <span>Mixer digitale ALLEN&HEATH GLD80</span><br />
      <span>Mixer digitale YAMAHA 01V96</span><br />
      <span>Mixer digitale YAMAHA DM1000/2000</span><br />
      <span>Mixer digitale YAMAHA LS9-32</span><br />
    </div>
  </div>
}

export const luci = {
  description: 'Per gli eventi sportivi notturni l’impianto luci è fondamentale per la buona riuscita dell’evento. Noleggiocampi.it dispone di diverse soluzioni in base alle strutture sportive installate con l’obiettivo di rendere ottimale la visuale di gioco per gli atleti con il giusto livello di potenza e inclinazione di fari e luci.'
}

const UList = styled.ul`
  font-size: 21px;
  padding: 0 1.2rem;

  @media ${device.laptop} {
    font-size: 16px;
  }

  @media ${device.laptopM} {
    column-count: 2;
    column-gap: 40px;
    list-style: outside disc;
  }

  @media ${device.laptopL} {
    font-size: 21px;
    column-gap: 50px;
  }
`

const ListItem = styled.li`
  @media ${device.laptopM} {
    margin-left: 1em
  }
`

class Extra extends Component {
  constructor (props) {
    super(props)
    this.state = {
      sticky: false
    }
  }

  componentDidMount () {
    Events.scrollEvent.register('begin', function () {
      console.log('begin', arguments)
    })

    Events.scrollEvent.register('end', function () {
      console.log('end', arguments)
    })

    window.addEventListener('scroll', this.handleScroll.bind(this))
  }

  handleScroll (event) {
    const sticky = this.menu && this.menu.offsetTop
    console.log(window.pageYOffset, sticky)
    if (window.pageYOffset > sticky - 100) {
      this.setState({ sticky: true })
    }

    if (window.pageYOffset < 165) {
      this.setState({ sticky: false })
    }
  }

  render () {
    return (
      <div>
        <Helmet>
          <title>Noleggio Gazebo Impianto Audio Impianto Luci</title>
          <meta name='Description' content='Offriamo una serie componenti aggiuntivi come Impianto audio, Impianto Luci, Casette check-in il legno e gazebi per completare l’allestimento del campo da gioco!' />
          <meta name='Keywords' content='casette in legno prezzi,noleggio gazebo,americana luci' />
        </Helmet>
        <Title>
          <Typography variant='h1' type='title'>EXTRA</Typography>
        </Title>
        <Menu innerRef={menu => (this.menu = menu)} className={this.state.sticky ? 'sticky' : ''}>
          <ScrollNav items={navItems} />
        </Menu>
        <Content>
          {/* CASETTA CHECK-IN */}
          <Element name='casetta'>
            <SplitSection
              slides={casettaSlides}
              reverse
              reverseMobile
            >
              <Typography padding='1.2rem 0' variant='h2' type='title'>CASETTA CHECK-IN</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {casetta.description}
              </Typography>
              <Typography padding='1.2rem 0' variant='h3' type='title'>INTERNI</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                <span>Gli interni della casetta sono personalizzabili e customizzabili a seconda delle diverse esigenze.</span><br />
                <span>È possibile installare mensole, cubotti, tavolini e TV che possano migliorare l’organizzazione interna dell’ambiente.</span>
              </Typography>
            </SplitSection>
            <SplitSection slides={casettaSlides}>
              <Typography padding='1.2rem 0' variant='h3' type='title'>SCHEDA TECNICA</Typography>
              <UList>
                {casetta.technical.map((item, i) => <ListItem key={i}>{item}</ListItem>)}
              </UList>
            </SplitSection>
          </Element>
          {/* GAZEBI */}
          <Element name='gazebi' >
            <TabSlider
              slides={gazeboSlides1}
              tabs={gazebo5x5.tabs}
              title='Personalizzazione'
              reverse
            >
              <Typography padding='1.2rem 0' variant='h2' type='title'>GAZEBO SPIDER 5x5</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {gazebo5x5.description}
              </Typography>
            </TabSlider>
            <TabSlider
              slides={gazeboSlides2}
              tabs={gazebo3x3.tabs}
              title='Personalizzazione'
            >
              <Typography padding='1.2rem 0' variant='h2' type='title'>GAZEBO STANDARD 3x3</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {gazebo3x3.description}
              </Typography>
            </TabSlider>
          </Element>
          {/* IMPIANTO AUDIO */}
          <Element name='audio'>
            <SplitSection slides={audioSlides} reverse>
              <Typography variant='h2' type='title'>IMPIANTO AUDIO</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {audio.description}
              </Typography>
              {/* <Typography padding='1.2rem 0' variant='h3' type='title'>SCHEDA TECNICA</Typography>
              <UList>
                <ListItem>Dimensioni singola transenna: 195×95 cm</ListItem>
                <ListItem>Materiale: ferro con trattamento fondo antiruggine e verniciatura nero opaco</ListItem>
                <ListItem>Montaggio con certificazione statica resistenza al vento (su richiesta)</ListItem>
                <ListItem>Morsetti in ferro e trattamento antiruggine per stabilizzare e unire più transenne tra loro</ListItem>
              </UList> */}
            </SplitSection>
          </Element>
          {/* IMPIANTO LUCI */}
          <Element name='luci'>
            <SplitSection slides={luciSlides}>
              <Typography variant='h2' type='title'>IMPIANTO LUCI</Typography>
              <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
                {luci.description}
              </Typography>
            </SplitSection>
          </Element>
        </Content>
        <Section>
          <BigTitle>
            <Typography variant='h2' type='title'>
              4 BUONI MOTIVI PER SCEGLIERE LE NOSTRE STRUTTURE
            </Typography>
          </BigTitle>
          <Features>
            {features.map(feature => (
              <FeatureWrapper>
                <Feature
                  icon={feature.icon}
                  title={feature.title}
                  description={feature.description}
                />
              </FeatureWrapper>
            ))}
          </Features>
        </Section>
      </div>
    )
  }
}

export default Extra



// WEBPACK FOOTER //
// ./src/components/Pages/Strutture/Extra.js